export default "__VITE_ASSET__41c7e555__"